import { merge } from 'lodash'
import baseEnum from './base-enum'
export let blocks = Object.assign({}, baseEnum, {
  list: [
    {
      title: 'Заголовок',
      icon: 'title',
      struct: {
        type: 'heading',
        value: '',
        meta: {
          variant: 'h2'
        }
      }
    },
    {
      title: 'Текст',
      icon: 'text_fields',
      struct: {
        type: 'text',
        value: ''
      }
    },
    {
      title: 'Текст в две колонки',
      icon: 'article',
      struct: {
        type: 'multiColumnText',
        value: []
      }
    },
    {
      title: 'Список',
      icon: 'list_alt',
      struct: {
        type: 'list',
        value: [],
        meta: {
          variant: 'ul'
        }
      }
    },
    {
      title: 'Картинка',
      icon: 'image',
      struct: {
        type: 'image',
        value: {
          src: '',
          hash: '',
          name: ''
        }
      }
    },
    {
      title: 'Текст с картинкой слева',
      icon: 'border_left',
      struct: {
        type: 'textWithLeftImage',
        value: {
          text: '',
          image: {
            src: '',
            hash: '',
            name: ''
          }
        }
      }
    },
    {
      title: 'Текст с картинкой справа',
      icon: 'border_right',
      struct: {
        type: 'textWithRightImage',
        value: {
          title: '',
          text: '',
          image: {
            src: '',
            hash: '',
            name: ''
          }
        }
      }
    },
    {
      title: 'Youtube видео',
      icon: 'videocam',
      struct: {
        type: 'video',
        value: ''
      }
    },
    {
      title: 'HTML',
      icon: 'code',
      struct: {
        type: 'html',
        value: ''
      }
    },
    {
      title: 'Галерея',
      icon: 'photo',
      struct: {
        type: 'gallery',
        value: [],
        meta: {
          display: {
            name: ''
          }
        }
      }
    },
    {
      title: 'Гиперссылка',
      icon: 'link',
      struct: {
        type: 'link',
        value: {
          name: '',
          url: ''
        }
      }
    },
    {
      title: 'Баннер',
      icon: 'auto_awesome_mosaic',
      struct: {
        type: 'banner',
        value: ''
      }
    },
    {
      title: 'Цитата',
      icon: 'format_quote',
      struct: {
        type: 'quote',
        value: ''
      }
    },
    {
      title: 'Лид форма',
      icon: 'dns',
      struct: {
        type: 'leadForm',
        value: ''
      }
    },
    {
      title: 'Форма поиска',
      icon: 'search',
      struct: {
        type: 'searchForm',
        value: {
          complex: null,
          rooms: [],
          price: {
            min: null,
            max: null
          },
          floor: {
            min: null,
            max: null
          },
          square: {
            min: null,
            max: null
          }
        }
      }
    },
    {
      title: 'Таблица',
      icon: 'apps',
      struct: {
        type: 'table',
        value: [
          [
            {
              value: '',
              attrs: {}
            },
            {
              value: '',
              attrs: {}
            },
            {
              value: '',
              attrs: {}
            }
          ],
          [
            {
              value: '',
              attrs: {}
            },
            {
              value: '',
              attrs: {}
            },
            {
              value: '',
              attrs: {}
            }
          ],
          [
            {
              value: '',
              attrs: {}
            },
            {
              value: '',
              attrs: {}
            },
            {
              value: '',
              attrs: {}
            }
          ]
        ]
      }
    }
  ].map(block => {
    return merge(block, {
      struct: {
        meta: {}
      }
    })
  })
})
